export enum PermissionCodeEnum {
  test = 'test',
  // Dataset
  DATASET_CREATE = 'dataset:dataset:create',
  DATASET_DELETE = 'dataset:dataset:delete',
  DATASET_QUERY = 'dataset:dataset:query',
  DATASET_QUERYDETAIL = 'dataset:dataset:queryDetail',
  DATASET_UPDATE = 'dataset:dataset:update',
  // Dataset - Data
  DATASET_DATA_DELETE = 'dataset:data:delete',
  DATASET_DATA_EXPORT = 'dataset:data:export',
  DATASET_DATA_QUERY = 'dataset:data:query',
  DATASET_DATA_UPLOAD = 'dataset:data:upload',
  DATASET_DATA_QUERYDETAIL = 'dataset:data:queryDetail',
  DATASET_DATA_UNLOCK = 'dataset:data:unlock',
  DATASET_DATA_CAMERACONFIG_EDIT = 'dataset:cameraConfig:edit',
  // Dataset - Ontology
  DATASET_ONTOLOGY_CREATE = 'dataset:ontology:create',
  DATASET_ONTOLOGY_DELETE = 'dataset:ontology:delete',
  DATASET_ONTOLOGY_EDIT = 'dataset:ontology:edit',
  DATASET_ONTOLOGY_QUERY = 'dataset:ontology:query',
  DATASET_ONTOLOGY_EXPORT = 'dataset:ontology:export',
  DATASET_ONTOLOGY_IMPORT = 'dataset:ontology:import',
  DATASET_ONTOLOGY_PIN = 'dataset:ontology:pin',
  DATASET_ONTOLOGY_TAG_EDIT = 'dataset:ontology:tag:edit',
  DATASET_ONTOLOGY_TAG_VIEW = 'dataset:ontology:tag:view',
  // Dataset - Class
  DATASET_CLASS_MAPWITHMODELCLASS = 'dataset:class:mapWithModelClass',
  // Dataset - Frames
  DATASET_FRAMES_COMBINE = 'dataset:frames:combine',
  DATASET_FRAMES_MERGE = 'dataset:frames:merge',
  DATASET_FRAMES_QUERY = 'dataset:frames:query',
  DATASET_FRAMES_REMOVE = 'dataset:frames:remove',
  // Ontology
  ONTOLOGY_ONTOLOGY_CREATE = 'ontology:ontology:create',
  ONTOLOGY_ONTOLOGY_DELETE = 'ontology:ontology:delete',
  ONTOLOGY_ONTOLOGY_EDIT = 'ontology:ontology:edit',
  ONTOLOGY_ONTOLOGY_QUERY = 'ontology:ontology:query',
  ONTOLOGY_ONTOLOGY_QUERYDETAIL = 'ontology:ontology:queryDetail',
  ONTOLOGY_ONTOLOGY_EXPORT = 'ontology:ontology:export',
  ONTOLOGY_ONTOLOGY_IMPORT = 'ontology:ontology:import',
  DATASET_ONTOLOGY_COPYFROM = 'dataset:ontology:copyFrom',
  ONTOLOGY_ONTOLOGY_COPYFROM = 'ontology:ontology:copyFrom',
  // Ontology - classes
  ONTOLOGY_CENTER_ONTOLOGY_CREATE = 'ontologyCenter:ontology:create',
  ONTOLOGY_CENTER_ONTOLOGY_DELETE = 'ontologyCenter:ontology:delete',
  ONTOLOGY_CENTER_ONTOLOGY_EDIT = 'ontologyCenter:ontology:edit',
  ONTOLOGY_CENTER_ONTOLOGY_QUERY = 'ontologyCenter:ontology:query',
  ONTOLOGY_CENTER_ONTOLOGY_PIN = 'ontologyCenter:ontology:pin',
  ONTOLOGY_CENTER_ONTOLOGY_TAG_EDIT = 'ontologyCenter:ontology:tag:edit',
  ONTOLOGY_CENTER_ONTOLOGY_TAG_VIEW = 'ontologyCenter:ontology:tag:view',

  // Model
  MODEL_VIEW = 'model:view',
  MODEL_RUN = 'model:run',
  MODEL_RUN_DELETE = 'model:runRecord:delete',
  MODEL_CUSTOM_VIEW = 'model:custom:view',
  MODEL_CUSTOM_CREATE = 'model:custom:create',
  MODEL_CUSTOM_EDIT = 'model:custom:edit',
  MODEL_CUSTOM_DELETE = 'model:custom:delete',
  // Tool
  TOOL_ANOTATE = 'tool:annotate',
  TOOL_MODEL = 'tool:model',
  TOOL_VIEW = 'tool:view',
  // Team
  TEAM_MEMBER_ADD = 'team:member:add',
  TEAM_MEMBER_QUERY = 'team:member:query',
  TEAM_MEMBER_DELETE = 'team:member:delete',
  TEAM_MEMBER_QUERYDETAIL = 'team:member:queryDetail',
  TEAM_MEMBER_REVIEW = 'team:member:review',
  TEAM_MEMBER_REVIEWLIST = 'team:member:viewReviewList',
  // Team - Tag
  TEAM_TAG_EDIT = 'team:tag:edit',
  TEAM_TAG_DELETE = 'team:tag:delete',
  TEAM_TAG_QUERY = 'team:tag:query',
  TEAM_TAG_ASSIGN = 'team:tag:assign',
  TEAM_TAG_QUERYMEMBER = 'team:tag:queryMember',
  // Team - Group
  TEAM_GROUP_CREATE = 'team:group:create',
  TEAM_GROUP_QUERY = 'team:group:query',
  TEAM_GROUP_QUERYMEMBER = 'team:group:queryMember',
  TEAM_GROUP_ADDMEMBER = 'team:group:addMember',
  TEAM_GROUP_DELETEMEMBER = 'team:group:deleteMember',
  TEAM_GROUP_EDIT = 'team:group:edit',
  TEAM_GROUP_DELETE = 'team:group:delete',
  TEAM_GROUP_QUERYDETAIL = 'team:group:queryDetail',
  // Team - Partner
  TEAM_PARTNER_VIEW = 'team:partner:view',
  TEAM_PARTNER_EDIT = 'team:partner:edit',
  TEAM_PARTNER_INVITE = 'team:partner:invite',
  TEAM_PARTNER_OPERATEREQUEST = 'team:partner:operateRequest',
  TEAM_PARTNER_DELETE = 'team:partner:delete',
  // Team - Role
  TEAM_ROLE_QUERY = 'team:role:query',
  TEAM_ROLE_CREATE = 'team:role:create',
  TEAM_ROLE_EDIT = 'team:role:edit',
  TEAM_ROLE_DELETE = 'team:role:delete',
  TEAM_ROLE_ASSIGN = 'team:role:assign',
  // Team - Setting
  TEAM_TEAM_TRANSFER = 'team:team:transferOwner',
  TEAM_TEAM_DELETE = 'team:team:delete',
  TEAM_TEAM_EDIT = 'team:team:edit',
  // Team - Billing
  TEAM_BILLING_VIEW = 'team:billing:view',
  TEAM_BILLING_CHANGE = 'team:billing:change',
  TEAM_BILLING_ADDADDTIONALMODELCALLS = 'team:billing:addAddtionalModelCalls',
  TEAM_BILLING_CHANGEPAYMENTMETHOD = 'team:billing:changePaymentMethod',
  TEAM_BILLING_DOWNLOADINVOICE = 'team:billing:downloadInvoice',
  // Team - Comment
  TEAM_COMMENTTYPE_VIEW = 'team:commentType:view',
  TEAM_COMMENTTYPE_SAVE = 'team:commentType:save',
  TEAM_COMMENTTYPE_DELETE = 'team:commentType:delete',

  // Cloud
  CLOUD_STORAGE_VIEW = 'cloud:storage:view',
  CLOUD_STORAGE_CREATE = 'cloud:storage:create',
  CLOUD_STORAGE_EDIT = 'cloud:storage:edit',
  CLOUD_STORAGE_DELETE = 'cloud:storage:delete',

  // Task
  TASK_TASK_CREATE = 'task:task:create',
  TASK_TASK_EDIT = 'task:task:edit',
  TASK_TASK_EDITSTATUS = 'task:task:editStatus',
  TASK_TASK_DELETE = 'task:task:delete',
  TASK_TASK_QUERY = 'task:task:query',
  TASK_TASK_STATISTIC = 'task:task:statistic',
  TASK_TASK_CLOSE = 'task:task:close',
  TASK_ADMIN_REVISE = 'task:admin:revise',
  TASK_ADMIN_ACCEPT = 'task:admin:accept',
  TASK_ADMIN_REJECT = 'task:admin:reject',
  TASK_INSPECT_STATISTIC = 'task:inspect:statistic',
  // Task - data
  TASK_DATA_ADD = 'task:data:add',
  TASK_DATA_ACC_LOCK = 'task:data:acc:lock',
  TASK_DATA_DELETE = 'task:data:delete',
  TASK_DATA_REASSIGN = 'task:data:reassign',

  TASK_TOOL_QA = 'task:tool:qa',

  // 这两个权限仅在demo team的visitor才会返回
  TASK_INSPECTORVISITOR_OPERATE = 'task:inspectorVisitor:operate',
  TASK_WORKVISITOR_CLAIMITEM = 'task:workVisitor:claimItem',
  // Task - Performance
  TASK_PERFORMANCE_TASKSUMMARY = 'task:performance:taskSummary',
  TASK_TASKPERFORMANCE_VIEW = 'task:taskPerformance:view',
  TASK_WORKERPERFORMANCE_VIEW = 'task:workerPerformance:view',

  // Task - Share
  TASK_SHARE_VIEW = 'task:share:view',
  TASK_SHARE_EDIT = 'task:share:edit',
  TASK_SHARE_MANAGEDATA = 'task:share:manageData',
  TASK_SHARE_TOOL_QA = 'task:share:tool:qa',
  // Task-Export
  TASK_RESULT_EXPORT = 'task:result:export',
  TASK_RESULT_ADMIN_EXPORT = 'task:result:admin:export',
  TASK_EXPORTRECORD_DELETE = 'task:exportRecord:delete',
  // Task - sample
  TASK_SAMPLE_CREATE = 'task:sample:create',
  TASK_SAMPLE_DELETE = 'task:sample:delete',
  TASK_SAMPLE_EDIT = 'task:sample:edit',
  TASK_SAMPLE_QUERY = 'task:sample:query',
  // Task -QA
  TASK_QCJ_OPERATE = 'task:qcj:operate',
  TASK_RULE_EDIT = 'task:rule:edit',

  // 质检
  DATASET_QA_RULE_EDIT = 'dataset:qa:rule:edit',
  DATASET_QCJ_REPORT_VIEW = 'dataset:qcj:report:view',
  DATASET_QCJ_VIOLATION_ANNOTATE = 'dataset:qcj:violation:annotate',
  DATASET_QCJ_CREATE = 'dataset:qcj:create',
  DATASET_QCJ_EDIT = 'dataset:qcj:edit',
  DATASET_QCJ_VIOLATION_VIEW = 'dataset:qcj:violation:view',
  DATASET_QA_VIEW = 'dataset:qa:view',

  // Project
  PROJECT_VIEW = 'project:view',
  PROJECT_CREATE = 'project:create',
  PROJECT_EDIT = 'project:edit',
  PROJECT_DELETE = 'project:delete',
  PROJECT_QCJ_VIEW = 'project:qcj:view',
  PROJECT_QCJ_OPERATE = 'project:qcj:operate',

  // Partner
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function setEmun(array) {
  array = [
    'dataset:qcj:report:view',
    'dataset:qcj:violation:annotate',
    'dataset:qcj:create',
    'dataset:qcj:edit',
    'dataset:qcj:violation:view',
  ];
  let b = '';
  array.map((i) => {
    b =
      b +
      i
        .replaceAll(' ', '_')
        .replaceAll('-', '_')
        .replaceAll('&', 'And')
        .replaceAll(':', '_')
        .toUpperCase() +
      "='" +
      i +
      "',";
  });
  console.log(b);
}
